import { SET_POSITION } from './constants';

export default function reducer(state = null, { type, payload }) {
  if (type === SET_POSITION) return payload;
  return state;
}




// WEBPACK FOOTER //
// ./src/app/position/reducer.js